:host ion-button {
    margin-top: 12px;
}

:host .HiddenPalette {
    display: none;
}

:host #SSPBSearchPaletteStage {
    border: 1px solid transparent;
}

:host ion-searchbar {
    min-width: 200px;
}
